import { InjectionToken } from '@angular/core';
import { OpenIdConfiguration } from 'angular-auth-oidc-client/lib/config/openid-configuration';

export const OID_CONFIG = new InjectionToken<OpenIdConfiguration>('OpenID Configuration');
